import { flickityAutoScroll } from './flickityAutoScroll'


export default () => {
	const els = [...document.querySelectorAll('.icon-roundel-columns')]
	els.map(el => {
		const carouselEl = el.querySelector('.icon-roundel-columns__inner')
		flickityAutoScroll(carouselEl)
	})	
}